<div class="shared-dialog" [attr.aria-busy]="pending()">
  <h1 mat-dialog-title class="shared-dialog__title">{{ title }}</h1>
  <div mat-dialog-content class="shared-dialog__content">
    <ng-content></ng-content>
  </div>
  @if (pending()) {
    <div class="shared-dialog__feedback" role="status">
      <mat-progress-bar
        mode="indeterminate"
        [attr.aria-label]="pendingLabel"
      ></mat-progress-bar>
      <span>{{ pendingLabel }}</span>
    </div>
  }
  @if (failed()) {
    <p class="shared-dialog__error" role="alert">{{ failureMessage }}</p>
  }
  <div class="shared-dialog__actions">
    <button
      mat-stroked-button
      type="button"
      [disabled]="pending()"
      (click)="close(false)"
    >
      {{ cancelLabel }}
    </button>
    <button
      mat-flat-button
      type="button"
      [color]="destructive ? 'warn' : 'primary'"
      [class.destructive]="destructive"
      [class.confirm]="!destructive"
      [disabled]="pending() || !confirmable"
      (click)="confirm()"
    >
      {{ confirmLabel }}
    </button>
  </div>
</div>
